// @flow
import { PRODUCT_ACTIVITIES } from 'Client/cms/toolkit/constants';
import { ProductActivitiesLine } from 'Components/lines/product-activities-line/ProductActivitiesLine';
import { productActivitiesResolver } from './productActivities.resolver';

export const productActivitiesDescriptor = {
  name: PRODUCT_ACTIVITIES,
  component: ProductActivitiesLine,
  resolve: productActivitiesResolver.resolve,
};
